import { Component, EventEmitter, Output } from '@angular/core';
import { Commission, PaymentService } from '@app/data-services/payment.service';
import { AuthService } from '@app/services/auth/auth.service';
import { filter, includes, forEach } from 'ramda';
import { catchError, finalize, switchMap, takeUntil } from 'rxjs/operators';
import { OnDestroyService } from '@modules/shared/services/on-destroy.service';
import { combineLatest, EMPTY } from 'rxjs';
import { MemberService } from '@app/data-services/member.service';
import { NzMessageService } from 'ng-zorro-antd';

declare var UIkit: any;

@Component({
    selector: 'app-payment-list',
    providers: [AuthService, OnDestroyService],
    templateUrl: './payment-list.component.html',
})
export class PaymentListComponent {
    @Output() onReady: EventEmitter<void> = new EventEmitter();

    totalPayment = 0;
    paymentList: Debt[] = [];
    commissions: Commission[] = null;

    appUser$ = this.memberService.appUser$;
    loadingPaymentList = false;

    constructor(
        private paymentService: PaymentService,
        private destroyService: OnDestroyService,
        private memberService: MemberService,
        private message: NzMessageService
    ) {
        this.getPaymentInformation();
    }

    private getPaymentInformation() {
        this.loadingPaymentList = true;
        this.paymentService
            .revalidateDebts()
            .pipe(
                switchMap(() =>
                    combineLatest([this.paymentService.paymentList$, this.paymentService.commission$]).pipe(
                        takeUntil(this.destroyService.onDestroy$)
                    )
                ),
                catchError(() => {
                    this.message.error('Hubo un error en el proceso.', { nzDuration: 10000 });
                    this.loadingPaymentList = false;
                    return EMPTY;
                })
            )
            .subscribe(([payDebts, commission]) => {
                this.loadingPaymentList = false;
                this.totalPayment = commission.totalWithCommission;
                this.paymentList = payDebts;
                this.commissions = [commission.commission];
            });
    }

    removeItem(debt: Debt) {
        UIkit.modal.confirm(
            '<b>¿ Esta seguro que desea eliminar el elemento seleccionado ?</b>',
            () => {
                this.paymentService.removeItem(debt);
                const siblings = filter((dbt: Debt) => includes(dbt.id, debt.siblingsIds), this.paymentList);
                forEach((dbt: Debt) => this.paymentService.removeItem(dbt), siblings);
            },
            { center: true }
        );
    }

    validationRemove(index: number) {
        return this.paymentList.length - 1 === index;
    }
}
